import map from "lodash/map";

import { ResultDetail } from "./result-detail";
import { ResultsSection } from "./results-section";
import { CompetencyBadge } from "@/components/upwage-badge";
import type { Screening } from "@/types/screeners";

interface FitSummaryProps {
  screening: Screening;
}

export const FitSummary = ({
  screening: { competencies, overallFit },
}: FitSummaryProps) => {
  if (!overallFit) {
    return null;
  }

  return (
    <ResultsSection title="Fit Summary">
      <ResultDetail
        label="Overall fit"
        value={<CompetencyBadge isOverallFit score={overallFit} />}
      />
      {map(
        competencies,
        (value, key) =>
          value.score && (
            <ResultDetail
              key={key}
              label={key}
              value={<CompetencyBadge score={value.score} />}
            />
          ),
      )}
    </ResultsSection>
  );
};
